export const AboutUsCategory: string = 'About us';
export const AbourUsAction: string = 'About us button: Clicked';
